export default __webpack_public_path__ + "static/brand-ampm-bg--mobile@1x-8d788bfe41a6d48711b14cc2a098f2fa.jpg";